/**
 * 格式化数字
 * @param value - 要格式化的数值
 * @param options - 格式化选项
 * @returns 格式化后的字符串
 */
interface FormatOptions {
  prefix?: string;        // 前缀，如 '$'
  suffix?: string;        // 后缀，如 'B'
  decimals?: number;      // 小数位数
  fallback?: string;      // 当值为 null 或 undefined 时显示的默认值
  useCommas?: boolean;    // 是否使用千分位分隔符
  compact?: boolean;      // 是否使用紧凑格式（如 1.2B 而不是 1,200,000,000）
}

export const formatNumber = (
  value: number | null | undefined,
  options: FormatOptions = {}
): string => {
  const {
    prefix = '',
    suffix = '',
    decimals = 1,
    fallback = '-',
    useCommas = true,
    compact = false
  } = options;

  // 处理空值
  if (value === null || value === undefined) {
    return fallback;
  }

  // 处理非数字值
  if (isNaN(value)) {
    return fallback;
  }

  let formattedValue: string;
  let finalSuffix = suffix;

  if (compact) {
    // 使用紧凑格式
    if (value >= 1e9) {
      formattedValue = (value / 1e9).toFixed(decimals);
      finalSuffix = 'B';
    } else if (value >= 1e6) {
      formattedValue = (value / 1e6).toFixed(decimals);
      finalSuffix = 'M';
    } else if (value >= 1e3) {
      formattedValue = (value / 1e3).toFixed(decimals);
      finalSuffix = 'K';
    } else {
      formattedValue = value.toFixed(decimals);
    }
  } else {
    // 使用标准格式
    formattedValue = value.toFixed(decimals);
    if (useCommas) {
      formattedValue = formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }

  return `${prefix}${formattedValue}${finalSuffix}`;
};

// 使用示例：
// formatNumber(1234.5678)                    // "$1,234.6"
// formatNumber(1234.5678, { prefix: '€' })   // "€1,234.6"
// formatNumber(1234567, { compact: true })   // "$1.2M"
// formatNumber(1234567890, { compact: true }) // "$1.2B"
// formatNumber(null)                         // "-"
// formatNumber(1234.5678, { decimals: 2 })   // "$1,234.57"
// formatNumber(1234.5678, { useCommas: false }) // "$1234.6" 